<template>
  <div class="rc-hyperlink-runtime">
    <el-form-item
      @mouseenter.stop.native="controlMouseOver(component, index)"
      @click.native="controlClick(component, index)"
      :prop="getProp"
      :rules="rules"
      :label="component.properties.sortType==='hidden' ? '' : component.name"
      :title="component.name"
      :class="{getClassByCopy,'hidden':component.properties.sortType==='hidden','to-top':component.properties.sortType==='toTop'}"
      ref="elFormItem">
      <el-tooltip class="component-explain-tooltip" v-if="component.properties.componentExplain" :content="component.properties.componentExplain" placement="bottom-start">
        <span class="fa fa-question-circle"></span>
      </el-tooltip>
      <el-input
        v-if="isCurrentNode"
        :class="[inputWidth && Number(inputWidth) < 30 && 'clear-padding']"
        :style="{width: inputWidth ? inputWidth + 'px' : '100%', maxWidth: '100%'}"
        @input="setValue"
        @change="customChangeEvent"
        :value="getComponentValue"
        :disabled="disabled || component.properties.readonly"
        :placeholder="component.properties.placeholder"
        :title="getComponentValue||component.properties.placeholder"
        maxlength="300"
        @focus="controlClick(component, index)"
        @blur="validateFormItem">
      </el-input>
      <a @click="openDialog" v-else>{{getComponentValue}}</a>
    </el-form-item>
    <el-dialog
      v-if="dialogVisible"
      :title="component.name"
      :visible.sync="dialogVisible"
      width="80%"
      top="10vh"
      append-to-body
      :close-on-click-modal="false"
      center
      class="rc-hyperlink-dialog">
      <report-runtime v-if="component.properties.link.dataSource==='inside'" :id="component.properties.link.reportId"></report-runtime>
      <iframe v-else :src="getComponentValue" class="iframe" frameborder="0"></iframe>
    </el-dialog>
  </div>
</template>

<script>
import { componentMixin, inputMixin } from './mixins'
import ReportRuntime from '../../../report/runtime/report-runtime.vue'

export default {
  name: 'rc-hyperlink',
  mixins: [ componentMixin, inputMixin ],
  components: {
    ReportRuntime
  },
  inject: ['currentMenu'],
  props: [ 'component', 'value', 'index', 'disabled' ],
  data () {
    return {
      dialogVisible: false,
      tempValue: '',
      state: false,
      isCurrentNode: false
    }
  },
  methods: {
    openDialog () {
      if (this.component.properties.readonly) {
        return false
      }
      if (this.component.properties.newDesign) {
        // 新设计打开新标签
        let href = this.value
        window.open(href, '_blank')
      } else {
        if (this.component.properties.openModel === 'dialog') {
          // 弹窗打开
          this.dialogVisible = true
        } else {
          // 新标签页打开
          let href
          if (this.component.properties.link.dataSource === 'outside') {
            href = this.component.properties.link.external
            window.open(href, '_blank')
          } else {
            this.currentMenu.id = this.component.properties.link.reportId
            this.currentMenu.uuid = new Date().valueOf()
          }
        }
      }
    },
    setValue (val) {
      this.tempValue = val
      this.state = true
      this.updateValue(val)
    },
    updateValue (val) {
      // 如果有空格,hasSpaceValue 先暂存空格
      val.match(/^\s+\s+$/) ? this.hasSpaceValue = val : this.hasSpaceValue = ''
      val = val === ' ' ? ' ' : val.trim()
      // 归档控件才需要传值
      if (this.component.archive.enable) {
        this.update(val)
      }
      this.$nextTick(() => {
        this.executeFunctions('change')
      })
    },
    initComponentHy () {
      // 1.纯老设计              一直a便签展示
      // 2.修改过的老设计/新设计   当前节点输入框展示，之后节点a便签
      if (this.component.properties.newDesign) {
        if (this.disabled) {
          this.isCurrentNode = false
        } else {
          this.isCurrentNode = true
          // 控件归档则更新归档值,未归档则只给文本框赋值
          if (this.component.archive.enable) {
            // 老设计url是外链
            if (this.component.properties.link && this.component.properties.link.external && this.component.properties.link.dataSource === 'outside') {
              this.update(this.component.properties.link.external)
            }
          } else {
            // 老设计url是外链
            if (this.component.properties.link && this.component.properties.link.external && this.component.properties.link.dataSource === 'outside') {
              this.tempValue = this.component.properties.link.external
            }
          }
        }
      } else {
        this.isCurrentNode = false
        // 老设计url是外链
        if (this.component.properties.link && this.component.properties.link.external && this.component.properties.link.dataSource === 'outside') {
          this.tempValue = this.component.properties.link.external
        }
      }
    }
  },
  computed: {
    getComponentValue () {
      // state是为了编辑的时候,如果本来有值,而值清空了应该是新的值
      if (this.component.archive.enable) {
        if (this.tempValue || (this.tempValue === '' && this.state)) {
          return this.tempValue
        } else {
          return this.value
        }
      } else {
        return this.tempValue
      }
    }
  },
  watch: {
    value (val) {
      // 定制需要直接改dataService的值,在归档情况下才行
      if (this.component.archive.enable) {
        this.hasSpaceValue ? this.tempValue = this.hasSpaceValue : this.tempValue = val
        this.hasSpaceValue = ''
      }
    }
  },
  mounted () {
    this.initComponentHy()
  }
}
</script>
<style lang="scss">
  .rc-hyperlink-dialog {
    .el-dialog {
      .el-dialog__body {
        height: 650px;
        padding: 15px;
        .iframe {
          width: 100%;
          height: 100%;
        }
      }
    }
  }
.rc-hyperlink-runtime {
  a{
      color: var(--primary, #528de3);
      cursor: pointer;
      white-space: nowrap;
      display:inline-block;
  }
  .component-explain-tooltip {
    color: #c0c2c1;
    cursor: pointer;
    top: 0px;
    position: relative;
    &:hover {
      color: #3a8ee6;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/form/runtime/components/rc-hyperlink.vue